(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class TypsFloatingHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section-header');
      if (!this.section) return;
      this.abort = new AbortController();
      this.update = this.update.bind(this);
      this.measure = this.measure.bind(this);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.section.classList.remove('shopify-section-header-hidden', 'animate');
      this.measure();
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this);
      window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', this.measure, { passive: true, signal: this.abort.signal });
      this.update();
    }
    measure() {
      const height = this.offsetHeight;
      this.section.style.setProperty('--typs-floating-height', `${height}px`);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      this.update();
    }
    update() {
      const scroll = Math.max(0, window.scrollY);
      // Keep the announcement bar above the menu until it scrolls out of view.
      const origin = this.section.getBoundingClientRect().top + window.scrollY;
      this.style.top = `${Math.max(0, origin - scroll)}px`;
      const start = Number(this.dataset.opacityStart || 100) / 100;
      const end = Number(this.dataset.opacityEnd || 82) / 100;
      const distance = Math.max(1, Number(this.dataset.fadeDistance || 240));
      const progress = Math.min(1, Math.max(0, scroll - origin) / distance);
      this.style.setProperty('--typs-header-alpha', String(start + (end - start) * progress));
      this.section.classList.toggle('scrolled-past-header', scroll > origin + this.offsetHeight);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.section?.style.removeProperty('--typs-floating-height');
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('typs-floating-header')) {
    customElements.define('typs-floating-header', TypsFloatingHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
